import { Link, Navigate, useParams } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import FlashcardFAQ from "../components/FlashcardFAQ";
import SeoHead from "../components/SeoHead";
import { findSujet } from "../data/connaissances";

const BASE_URL = "https://hejpoland.com";

export default function ConnaissanceSujet() {
  const { rubriqueId, sujetId } = useParams();
  const sujet = findSujet(rubriqueId, sujetId);

  if (!sujet) {
    return <Navigate to="/fr/connaissances" replace />;
  }

  const titreCourt = sujet.titreCourt || sujet.titre;
  const pageTitle = `${sujet.titre} | Connaissances | HejPoland`;
  const pageDescription = sujet.seoDescription || sujet.intro || "";
  const pagePath = `/fr/connaissances/${rubriqueId}/${sujetId}`;
  const canonical = `${BASE_URL}${pagePath}`;
  const breadcrumb = [
    { name: "Connaissances", path: "/fr/connaissances" },
    { name: titreCourt, path: pagePath },
  ];

  return (
    <div
      className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16"
      data-testid="connaissance-sujet-page"
    >
      <SeoHead
        title={pageTitle}
        description={pageDescription}
        canonical={canonical}
        breadcrumb={breadcrumb}
      />
      {/* Fil d'Ariane */}
      <nav
        aria-label="Fil d'Ariane"
        className="mb-8 text-sm text-slate-500"
        data-testid="connaissance-sujet-breadcrumb"
      >
        <ol className="flex flex-wrap items-center gap-1.5">
          <li>
            <Link
              to="/fr/"
              className="hover:text-slate-900 transition"
              data-testid="breadcrumb-accueil"
            >
              Accueil
            </Link>
          </li>
          <li aria-hidden="true">
            <ChevronRight className="w-3.5 h-3.5 text-slate-400" />
          </li>
          <li>
            <Link
              to="/fr/connaissances"
              className="hover:text-slate-900 transition"
              data-testid="breadcrumb-connaissances"
            >
              Connaissances
            </Link>
          </li>
          <li aria-hidden="true">
            <ChevronRight className="w-3.5 h-3.5 text-slate-400" />
          </li>
          <li
            aria-current="page"
            className="text-slate-900 font-medium"
            data-testid="breadcrumb-current"
          >
            {titreCourt}
          </li>
        </ol>
      </nav>

      {/* Hero */}
      <header className="mb-10" data-testid="connaissance-sujet-hero">
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-900 tracking-tight">
          {sujet.titre}
        </h1>
        {sujet.intro ? (
          <p className="text-slate-700 mt-4 leading-relaxed text-lg">
            {sujet.intro}
          </p>
        ) : null}
      </header>

      {/* Cartes */}
      <FlashcardFAQ
        titre="Questions"
        cards={sujet.cards}
        withSchema={sujet.withSchema}
      />
    </div>
  );
}
